// extracted by mini-css-extract-plugin
module.exports = {"videoHeader":"ManageVideos_videoHeader__3MnG4","listHeader":"ManageVideos_listHeader__3jepf","videoModal":"ManageVideos_videoModal__tK5CZ"};